export default "__VITE_ASSET__30d9a79f__"